import {
    getTranscriptById,
    getTranscriptMetadata,
} from '@nesso/transcript-contracts/transcript.queries';

export const getTranscriptByIdOutputSchema = getTranscriptById.output;
export const getTranscriptMetadataOutputSchema = getTranscriptMetadata.output;
